import { get, post, handleError } from '@/lib/http-adapter';

export interface ActiveTourResponse {
  tour: {
    show: boolean;
    version?: string;
  };
}

export const getActiveTour = async (): Promise<
  ActiveTourResponse | undefined
> => {
  try {
    return await get<ActiveTourResponse>('/public/tours/me');
  } catch (error) {
    handleError(error);
  }
};

export const dismissTour = async (
  version: string
): Promise<{ dismissed: boolean } | undefined> => {
  try {
    return await post(
      `/public/tours/${encodeURIComponent(version)}/dismiss`
    );
  } catch (error) {
    handleError(error);
  }
};
